import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    if (event.type === "change" && event.target.matches('[data-autocomplete-target~="hidden"]') && !event.target.value) return

    if (event.type === "keydown") {
      event.preventDefault()

      const autocomplete = event.target.closest('[data-controller~="autocomplete"]')
      if (autocomplete?.querySelector('[data-autocomplete-target~="hidden"]')?.value) return
    }

    this.element.requestSubmit()
  }
}
